import { Box, Stack } from '@mui/material';
import React from 'react';

import type { StatusChipType } from '../StatusChip';
import StatusChip from '../StatusChip';
import { MobileCaption, MobileSubtitle } from '../Typography';

export interface BoxItemChip {
  text: string;
  type?: StatusChipType;
}

export interface BoxItemProps {
  primaryText: string;
  amount: string | number;
  secondaryText?: string;
  chips?: BoxItemChip[];
  onClick?: () => void;
}

const BoxItem: React.FC<BoxItemProps> = ({
  primaryText,
  amount,
  secondaryText,
  chips = [],
  onClick,
}) => {
  const hasChips = Array.isArray(chips) && chips.length > 0;

  const handleClick = onClick ?? (() => {});

  return (
    <Box
      component="button"
      type="button"
      onClick={handleClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        border: 'none',
        borderRadius: 0,
        p: 0,
        py: 1.5,
        backgroundColor: 'transparent',
        cursor: 'pointer',
        textAlign: 'left',
        '&:hover': {
          backgroundColor: 'action.hover',
        },
        '&:not(:first-of-type)': {
          borderTop: 1,
          borderColor: 'divider',
        },
      }}
    >
      <Box sx={{ minWidth: 0, display: 'flex', alignItems: 'flex-start' }}>
        <Stack spacing={0.25}>
          {hasChips && (
            <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 0.5 }}>
              {chips.map((chip, i) => (
                <Box key={`${chip.text}-${i}`}>
                  <StatusChip text={chip.text} type={chip.type ?? 'default'} />
                </Box>
              ))}
            </Stack>
          )}
          <MobileSubtitle
            component="span"
            sx={{ fontSize: '1rem', fontWeight: 600, color: 'text.primary' }}
          >
            {primaryText}
          </MobileSubtitle>
          {secondaryText != null && secondaryText !== '' && (
            <MobileCaption
              component="span"
              sx={{ color: 'text.secondary', fontWeight: 400 }}
            >
              {secondaryText}
            </MobileCaption>
          )}
        </Stack>
      </Box>
      <MobileSubtitle
        component="span"
        sx={{
          flexShrink: 0,
          ml: 2,
          color: 'text.primary',
          fontSize: '1rem',
        }}
      >
        {amount}
      </MobileSubtitle>
    </Box>
  );
};

export default BoxItem;
